import {
  CompanyInvoice,
  CompanyInvoiceMode,
  CompanyInvoiceType,
  CompanyInvoiceWithRelations,
  JobType,
} from '@utilities-one/api-sdk';

import { isSplicingJobType } from '@/config/jobs';

interface InvoiceForSplicingCheck {
  items?: Array<{ jobSpecification?: { jobType?: string | null } | null }> | null;
}

export const isCreditMemo = (invoice: Pick<CompanyInvoice, 'mode'>): boolean =>
  invoice.mode === CompanyInvoiceMode.creditMemo;

export const hasParDiems = (invoice: Pick<CompanyInvoiceWithRelations, '_count'>): boolean => {
  return (invoice._count?.perDiemInvoiceItems ?? 0) > 0;
};

export const isMSAInvoice = (invoice: Pick<CompanyInvoiceWithRelations, 'type'>): boolean => {
  return invoice.type === CompanyInvoiceType.msa;
};

export const isVendorInvoice = (invoice: Pick<CompanyInvoiceWithRelations, 'type'>): boolean => {
  return invoice.type === CompanyInvoiceType.vendor;
};

export const isSplicingInvoice = (invoice: InvoiceForSplicingCheck): boolean => {
  const jobType = invoice.items?.[0]?.jobSpecification?.jobType;
  return !!jobType && isSplicingJobType(jobType as JobType);
};
